import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=76dfc504&scoped=true&"
import script from "./thankyou.vue?vue&type=script&lang=js&"
export * from "./thankyou.vue?vue&type=script&lang=js&"
import style0 from "./thankyou.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./thankyou.vue?vue&type=style&index=1&id=76dfc504&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "76dfc504",
  null
  
)

export default component.exports